



















































































































































































import {Component, Prop, Vue, Watch, Inject} from 'vue-property-decorator';
import NodesTree from '@/components/nodesTree/NodesTree.vue';
import {findNodeById} from '@/utils/nodeUtils';
import SelectionPM from '@c/controls/selectionList/SelectionPM.vue';
import {FilterItem, SelectionListFilterModel} from '@/components/controls/selectionList/interfaces';
import {pmoduleTypeFilter} from '@/components/nodeComponent/filters';
import SelectionListFilterMenu from '@/components/controls/selectionList/SelectionListFilterMenu.vue';
import {groupBy} from 'lodash';
import Loading from '@c/controls/Loading.vue';
import SimpleDialog from '@c/SimpleDialog.vue';
import nodeModule from '@/store/modules/entities/nodeModule';
import {NodeData} from '@/system/nodes/interfaces';
import {PModuleWithMeasurements} from '@/views/system/modules/interfaces';
import {MeasurementData} from '@/views/system/measurements/interfaces';
import {DtcpAccelerometerFrequencyAndBandwidth} from '@/views/system/modules/interfaces';
import {pmoduleStoresByTypeMap} from '@/views/system/modules/configurate';
import enumsModule from '@/store/modules/enumsModule';
import {getMeasurementById} from '@/utils/moduleUtils';
import {MeasurementType} from '@/views/system/measurements/enums';
import {SpectrumEventType} from '@/enums/diagrams';

@Component({components: {NodesTree, SelectionPM, SelectionListFilterMenu, Loading, SimpleDialog}})
export default class WidgetBindDataSource extends Vue {
  @Prop({required: false, default: true})
  mock!: boolean;

  // Показатель загрузки дерева узлов
  loadingTree = false;
  errorTree = false;

  // Показатель загрузки списка программных модулей
  loadingPModules = false;
  errorPModules = false;

  // Показатель загрузки списка измерений
  loadingMeasurements = false;
  errorMeasurements = false;

  // Показатель загрузки списка центральной частоты и ширины
  loadingFreqbands = false;
  errorFreqbands = false;

  // Модель диалогового окна
  dialog = false;

  @Watch('dialog')
  onDialogChanged(newValue: boolean) {
    if (!newValue) this.close();
  }

  @Prop({required: false, default: true})
  showPModules!: boolean;

  @Prop({required: false, default: true})
  showMeasurements!: boolean;

  @Prop({required: false, default: false})
  showFreqbands!: boolean;

  // Выбранный узел
  selectedNode: NodeData | null = null;

  // Скрыть модули дочерних узлов
  hideChildModules = false;

  @Watch('selectedNode')
  onSelectNode(node: NodeData | null) {
    this.loadPmodules(node);
  }

  // Индекс выбранного программного модуля
  selectedPModuleGUID = '';

  @Watch('selectedPModuleGUID')
  async onSelectPModule(guid: string) {
    const pmodule = this.pmodules.find(x => x.guid === guid);
    if (!pmodule) return;

    this.filteredFreqbands = [];
    this.selectedFreqbandsId = null;

    const apiStore = pmoduleStoresByTypeMap.get(pmodule.type) as any;
    const {data} = await apiStore.getById(pmodule.id);

    if (data.freqbands) {
      data.freqbands.forEach((el: any) => {
        this.filteredFreqbands.push(el);
      });
      this.filteredFreqbands.sort((x, y) =>
        x.central_frequency && y.central_frequency ? x.central_frequency - y.central_frequency : 0,
      );
    }

    this.filteredMeasurements = [];

    pmodule.measurements.forEach(x => {
      const measurement = this.measurements.find(y => x.measurementId == y.id);
      if (
        !measurement ||
        (this.presetMeasurementFilter?.length > 0 &&
          !this.presetMeasurementFilter.includes(measurement.type)) ||
        (measurement.type == MeasurementType.Spectrum &&
          this.spectrumTypeFilter?.length > 0 &&
          !this.spectrumTypeFilter.includes(measurement.spectrumType)) ||
        (this.angleFilter && !measurement.alias.includes('angle'))
      )
        return;
      this.filteredMeasurements.push(measurement);
    });
  }

  @Watch('measurementId')
  onMeasurementIdChanged(id: number | null) {
    this.selectedMeasurementId = id;
  }

  // Получение ширины диалогового окна виджета
  get width() {
    if (
      (!this.showPModules && this.showMeasurements) ||
      (this.showPModules && !this.showMeasurements)
    )
      return '66%';
    if (!this.showPModules && !this.showMeasurements) return '33%';
    return '100%';
  }

  get canSelect() {
    if (this.showPModules && this.selectedPModuleGUID == '') return false;
    if (this.showMeasurements && this.selectedMeasurementId == null) return false;
    if (this.selectedNode == null) return false;
    return true;
  }

  // Индекс выбранного измерения
  selectedMeasurementId: number | null = null;

  // Индекс выбранной цунтральной частоты
  selectedFreqbandsId: number | null = null;

  // Список узлов
  nodes: NodeData[] = [];

  // Список программных модулей
  pmodules: PModuleWithMeasurements[] = [];

  // Предустановленные данные
  @Prop({required: false})
  nodeId!: number;

  @Prop({required: false})
  moduleGUID!: string;

  @Prop({required: false})
  measurementId!: number;

  @Inject()
  measurements!: MeasurementData[];

  filteredMeasurements: MeasurementData[] = [];

  filteredFreqbands: DtcpAccelerometerFrequencyAndBandwidth[] = [];
  // Строка поиска узла
  searchNode = '';

  // Строка поиска программного модуля
  searchPM = '';

  // Действия при выборе
  onSelect() {
    const result: any = {
      nodeId: this.selectedNode?.id,
      nodeName: this.selectedNode?.name,
      moduleGUID: null,
      moduleType: null,
      measurementId: null,
      freqband: null,
    };

    if (this.showPModules && this.selectedPModuleGUID) {
      result.pmodule = this.pmodules.find(x => x.guid === this.selectedPModuleGUID);
      result.moduleGUID = this.selectedPModuleGUID;
      result.moduleType = this.pmodules.find(x => x.guid === this.selectedPModuleGUID)?.type;
    }
    if (this.showMeasurements && this.selectedMeasurementId !== null)
      result.measurementId = this.selectedMeasurementId;
    if (this.showFreqbands && this.selectedFreqbandsId !== null) {
      result.freqband = this.filteredFreqbands.filter(x => x.id == this.selectedFreqbandsId)[0];
    }
    this.$emit('select', result);
  }

  async mounted() {
    await this.getData();
  }

  // Получение данных
  async getData() {
    await this.loadTree();
    if (this.nodeId === undefined) return;
    const node = findNodeById(this.nodeId, this.nodes);
    if (node == null) return;
    this.selectedNode = node;

    if (this.moduleGUID === undefined) return;

    await this.loadPmodules(this.selectedNode);
    const pmodule = this.pmodules.find(x => x.guid === this.moduleGUID);
    if (!pmodule) return;

    this.selectedPModuleGUID = this.moduleGUID;
    // await this.loadMeasurements(config);

    if (this.measurementId === undefined) return;
    const measurement = getMeasurementById(this.measurements, this.measurementId);
    if (!measurement) return;
    if (measurement.id) this.selectedMeasurementId = measurement.id;
  }

  // Загрузка дерева узлов
  async loadTree() {
    try {
      await nodeModule.fetchAll();
      this.loadingTree = true;
      this.nodes = [...nodeModule.all];
    } catch {
      this.errorTree = true;
    } finally {
      this.loadingTree = false;
    }
  }

  // Загрузка программных модулей
  async loadPmodules(node: NodeData | null) {
    this.pmodules = [];
    this.selectedPModuleGUID = '';
    this.errorPModules = false;

    this.selectedMeasurementId = null;
    this.errorMeasurements = false;

    if (!node || !node.id) return;

    try {
      this.loadingPModules = true;
      this.pmodules = await nodeModule.getModules(node.id);
    } catch {
      this.errorPModules = true;
    } finally {
      this.loadingPModules = false;
    }
  }

  created() {
    this.selectedFilterItemKeys = [];
    this.pmodules.sort((x: any, y: any) => x.name.localeCompare(y.name));
  }

  /* Фильтрация программных модулей */

  // Показывам кнопку фильтра, если есть по чему фильтровать и нет предуставновленного фильтра
  get isShowFilter() {
    return pmoduleTypeFilter && this.filterItems.length > 1;
  }
  // Фильтр программных модулей по типу
  pmoduleTypeFilter: SelectionListFilterModel = pmoduleTypeFilter;

  // Статус кнопки фильтра
  filterStatus = false;

  // Список выбранных элементов в фильтре
  selectedFilterItemKeys: string[] = [];

  // Список отфильтрованных элементов при поиске и\или фильтре
  selectedFilterItems: FilterItem[] = [];

  // предустановленный фильтр с типом ПМ для выбора источника данных виджета
  @Prop({required: false})
  presetFilter!: string[];

  // предустановленный фильтр с типом Измерения для выбора измерений виджета
  @Prop({required: false})
  presetMeasurementFilter!: MeasurementType[];

  @Prop({required: false})
  angleFilter!: boolean;

  // предустановленный фильтр с типом спектра для выбора измерений виджета
  @Prop({required: false})
  spectrumTypeFilter!: SpectrumEventType[];

  // Получить ключ элемента
  getKey(item: any) {
    return item.guid;
  }

  // Список элементов фильтра
  get filterItems() {
    if (!this.pmoduleTypeFilter) return [];
    const filterItems: any[] = [];
    const groups = groupBy(this.pmodules, this.pmoduleTypeFilter.keyFieldName);
    for (const key in groups) {
      if (this.presetFilter?.length && !this.presetFilter.includes(key)) continue;

      const values = groups[key];
      if (values) {
        const firstElement: any = values[0];

        const type = enumsModule.moduleTypes.find((x: any) => x.value === firstElement.type);
        if (type) filterItems.push({key: parseInt(key), value: type.description});
      }
    }
    return filterItems;
  }

  // Список отфильтрованных программных модулей
  get filteredItems() {
    let items: any[] = this.pmodules.filter(
      (x: any) =>
        !this.searchPM ||
        this.selectedPModuleGUID === this.getKey(x) ||
        x.name.toLowerCase().includes(this.searchPM.toLowerCase()),
    );
    if (this.presetFilter?.length) items = this.getPresetFilteredItems(items);
    if (this.selectedFilterItems.length)
      items = this.getFilteredItems(items, this.selectedFilterItems);
    return items;
  }

  // Получить список программных модулей для предустановленного фильтра
  getPresetFilteredItems(items: any[]): any[] {
    if (!this.pmoduleTypeFilter) return items;
    const keyFieldName = this.pmoduleTypeFilter.keyFieldName;
    return items.filter((x: any) => this.presetFilter.includes(x[keyFieldName]));
  }

  // Получить отфильтрованные элементы выбора
  getFilteredItems(items: any[], selectedFilterItems: FilterItem[]): any[] {
    if (!this.pmoduleTypeFilter) return items;
    const keyFieldName = this.pmoduleTypeFilter.keyFieldName;
    const keys = selectedFilterItems.map(x => x.key);
    return items.filter(
      (x: any) => this.selectedPModuleGUID === this.getKey(x) || keys.includes(x[keyFieldName]),
    );
  }

  // Применить фильтр
  applyFilter() {
    if (!this.selectedFilterItemKeys.length) {
      this.clearFilter();
      return;
    }
    this.selectedFilterItems = this.filterItems.filter(x =>
      this.selectedFilterItemKeys.includes(x.key),
    );
    this.filterStatus = true;
  }

  // Очистить фильтр
  clearFilter() {
    this.selectedFilterItemKeys = [];
    this.selectedFilterItems = [];
    this.filterStatus = false;
  }

  //Строка v-alert фильтра
  get filterStr() {
    return `${this.pmoduleTypeFilter?.name}: ${this.selectedFilterItems.map(x => x.value).join()}`;
  }

  //Действия при закрытии диалогового окна
  close() {
    this.loadingTree = false;
    this.loadingPModules = false;
    this.loadingMeasurements = false;
    this.loadingFreqbands = false;

    this.errorTree = false;
    this.errorPModules = false;
    this.errorMeasurements = false;
    this.errorFreqbands = false;
  }
}
